export interface SingleValueChartProps {
  data: React.ReactNode
  className?: string
}

export default function SingleValueChart({ data, className }: SingleValueChartProps) {
  return (
    <div className={`${className} w-full h-full flex flex-col justify-center items-center @container`}>
      <span className="font-bold">{data}</span>
    </div>
  )
}
